<template>
<div>

  <v-container v-if="isLoading" class="d-flex align-center justify-center" style="height: 100vh;">
    <v-progress-circular :size="70" :width="7" :color="scdColor" indeterminate></v-progress-circular>
  </v-container>

  <div v-else class="__container">
	  <v-form ref="formDatiCliccatore">
      <!-- Dati Principali Cliccatore -->
	    <div class="_separator d-flex justify-space-between">
	      <span><span>Dati Personali di</span>&nbsp;<span :style="`color:${scdOrange}`">{{ usernameUtente }}</span></span>
	      <!-- BOTTONE SALVA (modalità modifica)-->
	      <div class="d-flex">
		      <v-btn
			      v-if="modalitaModificaAttiva"
			      depressed
			      rounded
			      x-small
			      class="_copy_button mr-2"
			      @click="salvaDati()"
			      :color="$refs?.formDatiCliccatore?.validate() ? 'secondary' : 'error'"
			      :loading="salvataggioDatiInCorso"
		      >
			      <template v-slot:loader>
				      <v-progress-circular
					      indeterminate
					      color="white"
					      size="12"
					      width="2"
				      ></v-progress-circular>
			      </template>
			      <v-icon
				      v-if="!$refs?.formDatiCliccatore?.validate()"
				      class="mr-1"
				      x-small
			      >
				      mdi-alert-outline
			      </v-icon>
			      <v-icon
				      v-if="ciSonoModifichePendenti"
				      class="mr-1"
				      x-small
			      >
				      mdi-pencil
			      </v-icon>
			      Salva
		      </v-btn>
		      
		      <v-btn
			      x-small
			      depressed
			      color="secondary"
			      @click="toggleModalitaModifica()"
			      style="color:white;"
		      >
			      <v-icon style="font-size:12px">
				      {{ modalitaModificaAttiva ? 'mdi-close-thick' : 'mdi-pencil' }}
			      </v-icon>
		      </v-btn>
	      </div>
	    </div>

		  <v-data-table
		    :items-per-page="itemsPerPage"
		    hide-default-header
		    hide-default-footer
		    :headers="headers"
		    :items="datiTabella"
		    dense
		    mobile-breakpoint="0"
	    >
	      <!-- <template v-slot:item.valore="props"> -->
	      <template slot="item" slot-scope="props">
	        <tr :style="`background-color:${props.item.pivot.colore_sfondo}`">
	          <td>
		          <div class="d-flex flex-column bla">
			          <div class="d-flex align-center justify-space-between">
				          <!-- TEXT -->
				          <!-- CAMPI TEXT ESCLUSI QUELLI NEL V-IF (cliente clickday) (modalità visualizzazione e modifica)-->
				          <v-text-field
					          v-if="props.item.tipo == 'text'
                    && props.item.nome_backend != 'codice_identificativo_az'
                    && props.item.nome_backend != 'altro_cl'
                    && computedClienteClickdayIt"
					          v-model="props.item.valore"
					          :rules="setTextFieldRules(props.item)"
					          :disabled="!modalitaModificaAttiva"
					          dense
					          :hide-details="!modalitaModificaAttiva"
					          style="margin:15px 0 0;"
				          >
					          <!-- :type="`${props.item.nome_backend == 'numero_emergenza' ? 'number' : 'text'}`" -->
					          <template v-slot:label>
						          <span v-html="props.item.nome_frontend"></span>
					          </template>
				          </v-text-field>
				          
				          <!-- CAMPI TEXT (solo per gli altri clienti) (modalità visualizzazione e modifica)-->
				          <v-text-field
					          v-if="props.item.tipo == 'text' && !computedClienteClickdayIt && props.item.nome_backend != 'altro_cl'"
					          v-model="props.item.valore"
					          :rules="[max100chars]"
					          :disabled="!modalitaModificaAttiva"
					          dense
					          :hide-details="!modalitaModificaAttiva"
					          style="margin:15px 0 0;"
					          class="1"
				          >
					          <template v-slot:label>
						          <span v-html="props.item.nome_frontend"></span>
					          </template>
				          </v-text-field>
				          
				          <!-- CAMPO TEXTAREA (per tutti) -->
				          <v-textarea
					          v-if="props.item.nome_backend == 'altro_cl'"
					          v-model="props.item.valore"
					          :disabled="!modalitaModificaAttiva"
					          dense
					          :hide-details="!modalitaModificaAttiva"
					          style="margin:15px 0 0;"
				          >
					          <template v-slot:label>
						          <span v-html="props.item.nome_frontend"></span>
					          </template>
				          </v-textarea>
				          
				          <!--CODICE IDENTIFICATIVO per cliente clickday (modalità modifica)-->
				          <v-text-field
					          v-if="props.item.nome_backend == 'codice_identificativo_az' && modalitaModificaAttiva && computedClienteClickdayIt"
					          v-model="props.item.valore"
					          :rules="[max100chars]"
					          dense
					          :hide-details="!modalitaModificaAttiva"
					          style="margin:15px 0 0;"
				          >
					          <template v-slot:label>
						          <span v-html="props.item.nome_frontend"></span>
					          </template>
				          </v-text-field>
				          
				          <!-- CODICE IDENTIFICATIVO CON NUMERI CHE INDICANO LA POSIZONE (solo cliente clickday) (modalità visualizzazione)-->
				          <div
					          v-if="props.item.nome_backend == 'codice_identificativo_az' && !modalitaModificaAttiva && computedClienteClickdayIt"
					          class="d-flex flex-column aling-center"
				          >
					          <div
						          style="font-size: 11px; line-height:13px; color:rgba(0, 0, 0, 0.7); margin-top:3px;"
						          v-html="props.item.nome_frontend"
					          ></div>
					          <div
						          :style="`font-size: 12px; color:${scdOrange}; line-height:0.5; margin-top:3px`"
						          class="codice_identificativo"
					          >
						          <span v-for="(obj) in primaRigaNumeri" :style="`color:${obj.color}`">{{ obj.char }}</span>
					          </div>
					          <div
						          :style="`font-size: 12px; color:${scdOrange}`"
						          class="codice_identificativo"
					          >
						          <span v-for="(obj) in secondaRigaNumeri" :style="`color:${obj.color}`">{{ obj.char }}</span>
					          </div>
					          <div
						          :style="`font-size: 12px; color: #0054CC; line-height:6px; margin-top:3px; margin-bottom:9px; font-weight: 600`"
						          class="codice_identificativo"
					          >{{ props.item.valore }}
					          </div>
					          
					          <!--<div :style="`font-size: 13px; color:${scdColor}`">{{ props.item.valore.slice(0, 31) }}</div>-->
					          <!--<div :style="`font-size: 13px; color:${scdColor}`">{{ props.item.valore.slice(31, props.item.valore.length) }}</div>-->
				          </div>
				          
				          <!-- CAMPO TIPO SELECT (modalità visualizzazione e modifica) -->
				          <v-select
					          v-if="props.item.tipo == 'select'"
					          v-model="props.item.valore"
					          :items="props.item.opzioni"
					          :disabled="!modalitaModificaAttiva"
					          dense
					          :hide-details="!modalitaModificaAttiva"
					          flat
					          :style="`margin:15px 0 0; max-width:${ modalitaModificaAttiva ? '258px' : '321px' };`"
				          >
					          <template v-slot:label>
						          <span v-html="props.item.nome_frontend"></span>
					          </template>
				          </v-select>
				          
				          <!-- CAMPO TIPO DATE (modalità visualizzazione e modifica) -->
				          <v-text-field
					          v-if="props.item.tipo == 'date'"
					          type="date" v-model="props.item.valore"
					          :disabled="!modalitaModificaAttiva"
					          dense
					          :hide-details="!modalitaModificaAttiva"
					          style="margin:15px 0 0;"
				          >
					          <template v-slot:label>
						          <span v-html="props.item.nome_frontend"></span>
					          </template>
				          </v-text-field>
				          
				          <!-- BOTTONE COPIA DI FIANCO
										(modalità visualizzazione)
										(per il codice identificativo è visibile solo agli altri clienti, mentre al cliente clickday lo mostro in mezzo ai tastini per copiare le prime/ultime n cifre)
									-->
				          <v-btn
					          v-if="!noTastoCopia.includes(props.item.nome_backend)
									  && !modalitaModificaAttiva
									  && (
										  (
											  (
												  props.item.nome_backend != 'codice_identificativo_az'
												  && props.item.nome_backend != 'codice_ditta_inail_az'
											  )
											  && computedClienteClickdayIt
										  )
										  || !computedClienteClickdayIt
									  )"
					          rounded
					          x-small
					          class="_copy_button"
					          v-clipboard:copy="props.item.tipo == 'date' ? dateITFormatDDMMYYYY(props.item.valore) : props.item.valore"
					          v-clipboard:success="onCopy"
					          v-clipboard:error="onError"
					          style="background-color:#6D94CD"
				          >
					          Copia
				          </v-btn>
			          </div>
			          
			          
			          <!-- TASTI PER CODICE IDENTIFICATIVO E CODICE DITTA (PER CLIENTE CLICKDAY) -->
			          <div
				          v-if="(props.item.nome_backend == 'codice_identificativo_az'
				          || props.item.nome_backend == 'codice_ditta_inail_az') && !modalitaModificaAttiva && computedClienteClickdayIt"
				          style="margin-bottom:8px"
				          class="d-flex justify-space-between"
			          >
				          <div>
					          <v-btn
						          v-for="n in nCifreDaCopiare"
						          :key="`prime_${n}_cifre`"
						          depressed
						          rounded
						          x-small
						          class="_copy_n_of_string_button"
						          style="background-color:#6D94CD"
						          v-clipboard:copy="ritornaPrimiNCaratteri(n, props.item.valore)"
						          v-clipboard:success="onCopy"
						          v-clipboard:error="onError"
					          >
						          {{ n }}
					          </v-btn>
				          </div>
				          <div>
					          <v-btn
						          v-if="!noTastoCopia.includes(props.item.nome_backend)
						          && !modalitaModificaAttiva
						          && (props.item.nome_backend == 'codice_identificativo_az' || props.item.nome_backend == 'codice_ditta_inail_az')"
						          depressed rounded x-small
						          class="_copy_button"
						          v-clipboard:copy="props.item.tipo == 'date' ? dateITFormatDDMMYYYY(props.item.valore) : props.item.valore"
						          v-clipboard:success="onCopy" style="background-color:#6D94CD"
						          v-clipboard:error="onError"
					          >
						          Copia
					          </v-btn>
				          </div>
				          <div>
					          <v-btn
						          v-for="n in nCifreDaCopiareReversed"
						          :key="`prime_${n}_cifre`"
						          depressed
						          rounded
						          x-small
						          class="_copy_n_of_string_button"
						          v-clipboard:copy="ritornaUltimiNCaratteri(n, props.item.valore)"
						          v-clipboard:success="onCopy"
						          v-clipboard:error="onError"
						          style="background-color:#6D94CD"
					          >
						          {{ n }}
					          </v-btn>
				          </div>
			          </div>
		          </div>
		          
		          <div
			          v-if="props.item.nome_backend == 'cod_uni_ismea' && !modalitaModificaAttiva && computedClienteClickdayIt"
			          style="margin-bottom:8px"
			          class="d-flex justify-space-between"
		          >
			          <div>
				          <v-btn
					          rounded
					          x-small
					          class="_ismea_button"
					          style="background-color:#6D94CD"
					          v-clipboard:copy="ritornaPrimiNCaratteri(5, props.item.valore)"
					          v-clipboard:success="onCopy"
					          v-clipboard:error="onError"
				          >
					          {{ ritornaPrimiNCaratteri(5, props.item.valore) }}
				          </v-btn>
				          <v-btn
					          rounded
					          x-small
					          class="_ismea_button"
					          style="background-color:#6D94CD"
					          v-clipboard:copy="ritornaPorzioneDiUnaStringa(6, 11, props.item.valore)"
					          v-clipboard:success="onCopy"
					          v-clipboard:error="onError"
				          >
					          {{ ritornaPorzioneDiUnaStringa(6, 11, props.item.valore) }}
				          </v-btn>
				          <v-btn
					          rounded
					          x-small
					          class="_ismea_button"
					          style="background-color:#6D94CD"
					          v-clipboard:copy="ritornaUltimiNCaratteri(2, props.item.valore)"
					          v-clipboard:success="onCopy"
					          v-clipboard:error="onError"
				          >
					          {{ ritornaUltimiNCaratteri(2, props.item.valore) }}
				          </v-btn>
			          </div>
			          <!--<div>-->
				        <!--  <v-btn-->
					      <!--    v-if="!noTastoCopia.includes(props.item.nome_backend)-->
						    <!--      && !modalitaModificaAttiva-->
						    <!--      && (props.item.nome_backend == 'codice_identificativo_az' || props.item.nome_backend == 'codice_ditta_inail_az')"-->
					      <!--    depressed rounded x-small-->
					      <!--    class="_copy_button"-->
					      <!--    v-clipboard:copy="props.item.tipo == 'date' ? dateITFormatDDMMYYYY(props.item.valore) : props.item.valore"-->
					      <!--    v-clipboard:success="onCopy" style="background-color:#6D94CD"-->
					      <!--    v-clipboard:error="onError"-->
				        <!--  >-->
					      <!--    Copia-->
				        <!--  </v-btn>-->
			          <!--</div>-->
			          <!--<div>-->
				        <!--  <v-btn-->
					      <!--    v-for="n in nCifreDaCopiare"-->
					      <!--    :key="`prime_${n}_cifre`"-->
					      <!--    depressed-->
					      <!--    rounded-->
					      <!--    x-small-->
					      <!--    class="_copy_n_of_string_button"-->
					      <!--    v-clipboard:copy="ritornaUltimiNCaratteri(n, props.item.valore)"-->
					      <!--    v-clipboard:success="onCopy"-->
					      <!--    v-clipboard:error="onError"-->
					      <!--    style="background-color:#6D94CD"-->
				        <!--  >-->
					      <!--    {{ n }}-->
				        <!--  </v-btn>-->
			          <!--</div>-->
		          </div>
		          
	          </td>
	        </tr>
	      </template>
	    </v-data-table>
		  
	  </v-form>
	  
	  <!--<iframe-->
		<!--  src="https://time.is/clock"-->
		<!--  width="100%"-->
	  <!--&gt;</iframe>-->
	  
	  <v-snackbar v-model="snack" :timeout="snackTimeout" :color="snackColor">
		  <span :style="`font-weight:500; font-size:16px; letter-spacing:1px;`">{{ snackText }}</span>
		  <template v-slot:action="{ attrs }">
			  <v-btn v-bind="attrs" text @click="snack = false">Chiudi</v-btn>
		  </template>
	  </v-snackbar>
	  
	  <v-dialog
		  v-model="ciSonoModifichePendentiDialog"
		  max-width="700"
		  persistent
	  >
		  <v-card>
			  <v-card-title class="no-break-words">
				  Ci sono modifiche non salvate, se esci verranno perse!
			  </v-card-title>
			  
			  <v-card-actions>
				  <v-spacer></v-spacer>
				  <v-btn
					  rounded
					  color="secondary"
					  
					  class="px-6"
					  @click="ciSonoModifichePendentiDialog = false"
				  >
					  Annulla e torna alle modifiche
				  </v-btn>
				  <v-btn
					  rounded
					  color="secondary"
					  class="px-6"
					  @click="chiudiSenzaSalvare()"
				  >
					  Esci
				  </v-btn>
				  
			  </v-card-actions>
		  </v-card>
	  </v-dialog>
  </div>

</div>
</template>

<script>
import mixin from '../mixins';

export default {
  props: {
	  IdUtenteProp: {
		  default: null
	  }
  },
  mixins: [mixin],
  data() {
    return {
      idUtente: this.IdUtenteProp,

      isLoading: true,
	    isSettingDatiCliccatore: false,
      // isSaving: false,

      modalitaModificaAttiva: false,

      modificheAbilitate: true,

      // quando disabilito il v-text-field imposto a false queste due variabili
      isLarge: true,
      isPersistent: true,

      snack: false,
      snackColor: '',
      snackText: '',
      snackTimeout: 3000,

      max100chars: v => !v || v.length <= 100 || 'Troppo lungo!',
      pagination: {},
      itemsPerPage: 99,
      headers: [
        // { text: 'Titolo', align: 'start', sortable: false, value: 'titolo'},
        { text: 'Valore', align: 'start', sortable: false, value: 'valore' },
      ],

      datiTabella: [],
      datiModificabili: {},

      noTastoCopia: [],

      menu: [],

      nCifreDaCopiare: [3, 4, 5, 6, 7, 8],
	    
	    backupDatiTabella: {},
	    ciSonoModifichePendentiDialog: false,
	    
	    salvataggioDatiInCorso: false,
	    
	    // widgetId: 'Rome_z723'
	    
	    dataOra: null

    }
  },
	
  async created() {
		this.isSettingDatiCliccatore = true;
		
    this.areModificheAbilitate();
    await this.getDatiCliccatore();
	  
	  this.backupDatiTabella = JSON.parse(JSON.stringify(this.datiTabella));
	  
		this.isSettingDatiCliccatore = false;
	  
	  // setInterval(this.fetchTime, 1000); // Aggiorna ogni secondo
  },

	computed: {
		primaRigaNumeri() {
			let inserimenti = 0;
			let numeroPosizione = 0;
			let stringaFinale = [];
			let index = 0;
      let colorFlag = true;

			while (index < 65) {
        stringaFinale.push({
          char: numeroPosizione,
          color: colorFlag ? '#e6901c' : '#1cc1e6'
        })
				// stringaFinale[index].char = numeroPosizione;
        // stringaFinale[index].color = colorFlag ? '#e6901c' : '#d57300';
				inserimenti++;
				if ((inserimenti == 9 && numeroPosizione == 0) || (inserimenti == 10 && numeroPosizione != 0)) {
					numeroPosizione++;
					inserimenti = 0;
          colorFlag = !colorFlag;
				}
				index++;
			}
			return stringaFinale;
		},
		secondaRigaNumeri() {
			let inserimenti = 0;
			let numeroPosizione = 1;
			let stringaFinale = [];
			let index = 0;
			let primaSerie = true;
      let colorFlag = true;

			while (index < 65) {
        stringaFinale.push({
          char: numeroPosizione,
          color: colorFlag ? '#e6901c' : '#1cc1e6'
        })
				inserimenti++;
				numeroPosizione++;
				if ((primaSerie && index == 8) || (inserimenti == 10 && index >= 9)) {
					primaSerie = false;
					numeroPosizione = 0;
					inserimenti = 0;
          colorFlag = !colorFlag;
				}
				index++;
			}
			return stringaFinale;
		},
		ciSonoModifichePendenti() {
			if (!this.isSettingDatiCliccatore) {
				return this.datiTabella.some((item, index) => {
					return item.valore !== this.backupDatiTabella[index].valore;
				});
			}
			return false;
		},
		nCifreDaCopiareReversed() {
			return [...this.nCifreDaCopiare].reverse();
		}
	},
	
	watch: {
		ciSonoModifichePendenti(val) {
			this.$emit('ci-sono-modifiche-pendenti', val)
		}
	},

  methods: {
    getDatiCliccatore() {
      this.isLoading = true
	    
      return axios.get('/getDatiCliccatore', {
				params: {
					idUtente: this.idUtente
				}
      })
      // .get(this.IdUtente ? '/getDatiCliccatore/' + this.IdUtente : '/getDatiCliccatore')
      .then(response => {
        this.datiTabella = response.data.datiTabella;
        // this.idUtente = response.data.idUtente;
        this.usernameUtente = response.data.usernameUtente;
        this.noTastoCopia = response.data.campiDiTipoSelect;

        this.datiTabella.forEach(dato => {
          if (dato.tipo == 'date') {
            dato.valore = this.dateSTDFormat(dato.valore);
          }
          this.menu[dato.nome_backend] = false;
        })
      })
      .finally(() => {
        this.isLoading = false;
      })
    },
    // async salvaDato (valore, nome_backend) {
		//
    //   if (valore == '') {
    //     valore = null;
    //   }
		//
    //   await this.areModificheAbilitate();
		//
    //   if (!this.modificheAbilitate) {
    //     return;
    //   }
		//
    //   if (nome_backend.includes('data_') && moment(valore, "YYYY-MM-DD", true).isValid()) {
    //     valore = moment(valore, "YYYY-MM-DD").format('DD/MM/YYYY');
    //   }
		//
    //   axios.patch("/datiCliccatore", {
    //     valore: valore,
    //     nomeColonnaDB: nome_backend,
    //     idUtente: this.idUtente
    //   })
    //   .then(response => {
    //     this.snackColor = response.data.color
    //     this.snackText = response.data.message
    //     if (this.snackColor == 'error') {
    //       this.snackTimeout = 10000;
    //     } else {
    //       this.snackTimeout = 3000;
    //     }
    //     this.snack = true
    //   })
    // },
	  async salvaDati() {
			if (!this.$refs.formDatiCliccatore.validate()) return;
		 
			this.salvataggioDatiInCorso = true;
		  
		  await this.areModificheAbilitate();
		  if (!this.modificheAbilitate) return;
		  
		  const datiModificabili = {};
		  this.datiTabella.forEach(dato => {
			  if (dato.nome_backend.includes('data_') && moment(dato.valore, "YYYY-MM-DD", true).isValid()) {
				  const dataFormattata = moment(dato.valore, "YYYY-MM-DD").format('DD/MM/YYYY');
				  datiModificabili[dato.nome_backend] = dataFormattata;
			  }
				else datiModificabili[dato.nome_backend] = dato.valore
		  });
		  
		  axios.patch("/datiCliccatore", {
			  datiModificabili: datiModificabili,
			  idUtente: this.idUtente
		  })
			  .then(response => {
				  this.snackColor = response.data.color
				  this.snackText = response.data.message
				  if (this.snackColor == 'error') {
					  this.snackTimeout = 10000;
				  } else {
					  this.backupDatiTabella = JSON.parse(JSON.stringify(this.datiTabella));
					  this.snackTimeout = 3000;
				  }
				  this.snack = true
			  })
			  .finally(() => this.salvataggioDatiInCorso = false)
	  },
    areModificheAbilitate() {
      axios.get('/getModificheAbilitate')
        .then(response => {      
          this.modificheAbilitate = response.data.modificheAbilitate;

          if (!this.modificheAbilitate) {
            this.snack = true
            this.snackColor = 'warning'
            this.snackText = `L'amministratore ha disabilitato le modifiche`;
          }
      })
    },
    async toggleModalitaModifica() {
      await this.areModificheAbilitate();

      if (!this.modificheAbilitate) return;

      // se sono in modalità modifica attiva vuol dire che sto uscendo, quindi ripristino i valori dal database
      if (this.modalitaModificaAttiva) {
	      if (this.ciSonoModifichePendenti) {
		      this.ciSonoModifichePendentiDialog = true;
					return;
	      }
				else this.ripristinaDatiTabellaOriginali();
       
      }

      this.modalitaModificaAttiva = !this.modalitaModificaAttiva;
			// this.$emit('toggle-modalita-modifica', this.modalitaModificaAttiva)
    },
	  chiudiSenzaSalvare() {
			this.ripristinaDatiTabellaOriginali();
		  this.ciSonoModifichePendentiDialog = false;
		  this.toggleModalitaModifica();
	  },
	  ripristinaDatiTabellaOriginali() {
		  this.datiTabella = JSON.parse(JSON.stringify(this.backupDatiTabella));
	  },
    onCopy(e) {
      e.trigger.style.backgroundColor = "#4caf50"
      setTimeout(function(){
        e.trigger.style.backgroundColor = "#6D94CD"
      }, 1000);
    },
    onError(e) {
      e.trigger.style.backgroundColor = "#ff5252"
      setTimeout(function(){
        e.trigger.style.backgroundColor = "#6D94CD"
      }, 1000);
    },
    ritornaPrimiNCaratteri(n, stringa) {
      return stringa.slice(0, n)
    },
    ritornaUltimiNCaratteri(n, stringa) {
      let len = stringa.length;
      return stringa.slice(len - n, len)
    },
	  ritornaPorzioneDiUnaStringa(inizio, fine, stringa) {
		  return stringa.substring(inizio, fine);
	  },
	  setTextFieldRules(item) {
			if (item.nome_backend == 'numero_emergenza') return [this.max100chars, this.vincoli.numero_di_emergenza];
			else if (item.nome_backend == 'numero_cellulare_cl') return [this.max100chars, this.vincoli.numero_cellulare_cl];
			else if (item.nome_backend.includes("dataora_momento")) return [this.max100chars, this.vincoli.data_ora_italia]
		  else return [this.max100chars];
	  },
	  // async fetchTime() {
		//   // const url = `https://timeapi.io/api/time/current/zone?timeZone=Europe%2FAmsterdam`;
		//   // const response = await fetch(url);
		//   // const data = await response.json();
		//
		//   axios.get('https://timeapi.io/api/time/current/zone?timeZone=Europe%2FAmsterdam')
		// 	  .then(response => {
		// 			this.dataOra = this.formatDateTimeToItalyLong(response.data.dateTime);
		// 		  // console.log(this.formatDateTimeToItalyLong(response.data.dateTime))
		// 		  // console.log("Ora corrente:", response.data.time);
		// 	  })
	  // },
	  // formatDateTimeToItalyLong(datetime) {
		//   if (!datetime) return null
		//   const options = {
		// 	  year: 'numeric',
		// 	  month: '2-digit', // Cambiato da 'long' a '2-digit'
		// 	  day: '2-digit',
		// 	  hour: '2-digit',
		// 	  minute: '2-digit',
		// 	  second: '2-digit',
		// 	  // fractionalSecondDigits: '2-digit'
		//   };
		//   return new Date(datetime).toLocaleString(
		// 	  'it-it', options
		//   ); // 18/02/2019, 18:22:54
	  // },
  },
}
</script>

<style scoped lang="scss">
  // @import '~vuetify/src/styles/styles.sass';
	@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@200;300;400;500;600;700&display=swap');
  .__container {
    // max-width: 500px;
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  ._copy_button {
    margin-left: 10px;
    color: white;
  }
  ::v-deep ._copy_n_of_string_button {
    margin-left: 1px;
    min-width: 25px !important;
    padding: 0 !important;
    color: white;
  }
  ::v-deep ._ismea_button {
    margin-left: 1px;
    min-width: 25px !important;
    //padding: 0 !important;
    color: white;
  }

  ::v-deep {
    .v-small-dialog__activator {
      width: 100%;
    }
    .v-small-dialog__activator__content {
      width: 100%;
    }
    .theme--light.v-input input, 
    .theme--light.v-input textarea,
    .theme--light.v-select .v-select__selection {
      color: rgb(230, 144, 28);
	    font-weight: 600;
    }
    // .theme--light.v-input--is-disabled, 
    .theme--light.v-input--is-disabled input, 
    .theme--light.v-input--is-disabled textarea,
    .theme--light.v-select .v-select__selection--disabled {
      color: #0054CC;
	    font-weight: 600;
    }
    // .theme--light.v-input, 
    
    // .theme--light.v-input--is-disabled {
    //   color: #6D94CD;
    // }
    .break-word input {
      word-wrap: break-word;
      width: 100%;
    };
    .v-input__slot::before {
      border-style: none !important;
    }
    // .dato-wrapper {
    //   max-width: 100px;
    //   overflow: hidden;
    // }
    // tbody tr:nth-of-type(odd) {
    //   background-color: rgba(0, 0, 0, .05);
    // }
    .v-data-table {
      border-bottom: 1px solid #6D94CD;
      border-left: 1px solid #6D94CD;
      border-right: 1px solid #6D94CD;
      // border-top-left-radius: 0;
      // border-top-right-radius: 0;
      border-radius: 0;
      & td {
        padding: 0 5px !important;
      }
    }
    .v-data-table.numero-emergenza {
      margin-top: 5px;
      border-radius: 5px;
      border: 1px solid #6D94CD;
    }
    .v-data-table.numero-emergenza tbody tr {
      background-color: rgba(109, 148, 205, 0.3);
    }
    .v-expansion-panel-content__wrap {
      padding: 0;
    }
    .v-expansion-panel-header {
      margin-top: 5px;
      border: 1px solid #6D94CD;
      font-weight: bold;
      color: #6D94CD;
      background-color: #fff;
      border-radius: 5px;
    }
    .v-expansion-panel-header--active {
      min-height: 0px;
      border-top: 1px solid #6D94CD;
      border-left: 1px solid #6D94CD;
      border-right: 1px solid #6D94CD;
    }
    .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
      color: #6D94CD;
    }
    .v-snack__wrapper {
      min-width: 200px !important;
      width: 90vw !important;
    }

    .v-text-field__slot,
    .v-select__slot {
      & .v-label {
        font-size: 15px;
      }
      & input,
      .v-select__selections,
      textarea {
        font-size: 13px;
        padding: 0 !important;
      }
	    textarea {
		    line-height: 1.7;
	    }
    }


    .theme--light.v-label--is-disabled {
      color: rgba(0,0,0,.7);
    }
  }
    
  ._separator {
    display: flex;
    align-items: center;
    color: #6D94CD;
    background-color: white;
    height: 32px;
    font-size: 14px;
    font-weight: bold;
    margin-top: 5px;
    padding: 0 5px;
    // border-top-left-radius: 5px;
    // border-top-right-radius: 5px;
    border-top: 1px solid #6D94CD;
    border-left: 1px solid #6D94CD;
    border-right: 1px solid #6D94CD;
    & > span {
      // display: flex;
      // max-width: 145px;
    }
  }
  
	::v-deep {
		.codice_identificativo,
	  .codice_identificativo span {
			font-family: 'Roboto Mono', monospace !important;
		}
	}
  
  .no-break-words {
	  word-break: normal;
	  overflow-wrap: normal;
	  white-space: normal;
	  hyphens: none;
  }
</style>